import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue'

import MessengersPage from '@/pages/settings/messengers.vue'
import NewsfeedPage from '@/pages/settings/newsfeed.vue'
import AuthPage from '@/pages/settings/auth.vue'
import {RouteConfig} from 'vue-router'

// @ts-ignore
import messages from '@/lang/index'

const settings: RouteConfig = {
  path: '/settings',
  name: 'settings',
  meta: {
    pageName: messages.common.sidebar_links.settings
  },
  component: DashboardLayout,
  redirect: '/settings/messengers',
  children: [
    {
      path: 'messengers',
      name: 'messengersPage',
      meta: {
        pageName: messages.messeger.messengers_settings
      },
      component: MessengersPage
    },
    {
      path: 'news',
      name: 'newsPage',
      meta: {
        pageName: messages.messeger.messengers_settings
      },
      component: NewsfeedPage
    },
    {
      path: 'auth',
      name: 'authPage',
      meta: {
        pageName: messages.common.auth
      },
      component: AuthPage
    }
  ]
}

export default settings